import { useTranslation } from "react-i18next"
import { PricingPlan } from "@/components/pricing/PricingPlan"

export const Pricing = () => {
  const { t } = useTranslation("pricing")

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">{t("title")}</h2>
        <p className="text-xl text-gray-600 text-center mb-12 max-w-2xl mx-auto">{t("subtitle")}</p>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-6 xl:gap-10">
          <PricingPlan
            name={t("plans.basic.name")}
            price={{
              monthly: t("plans.basic.price.monthly"),
              yearly: t("plans.basic.price.yearly"),
            }}
            description={t("plans.basic.description")}
            features={t("plans.basic.features", { returnObjects: true }) as string[]}
            stripePriceIds={{
              yearly: "price_1QdaxDKmB8uw4YkbvkHXtFGj",
            }}
            savingsPercentage={25}
          />

          <PricingPlan
            name={t("plans.standard.name")}
            price={{
              monthly: t("plans.standard.price.monthly"),
              yearly: t("plans.standard.price.yearly"),
            }}
            description={t("plans.standard.description")}
            features={t("plans.standard.features", { returnObjects: true }) as string[]}
            isPopular
            stripePriceIds={{
              yearly: "price_1QdaxFKmB8uw4YkbGUYRkQfJ",
            }}
            savingsPercentage={25}
          />

          <PricingPlan
            name={t("plans.premium.name")}
            price={{
              monthly: t("plans.premium.price.monthly"),
              yearly: t("plans.premium.price.yearly"),
            }}
            description={t("plans.premium.description")}
            features={t("plans.premium.features", { returnObjects: true }) as string[]}
            isBestValue
            savingsPercentage={25}
          />
        </div>
      </div>
    </section>
  )
}
